import axios from './axios'
import qs from "qs";

function service(endpoint) {

    function fetchStepsWithProjectSteps(projectId, data) {
        return axios.get(`${endpoint}/${projectId}`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    return {
        fetchStepsWithProjectSteps
    }
}

export default service
